import React, { useEffect, useState } from 'react';

export const FieldRow = ({ row, FieldSelectOptions, createNewParamRow }) => {
  const [key, setKey] = useState('');
  const [value, setValue] = useState('');

  const onKeyChange = (value) => {
    if (value) {
      setKey(value);
      row['key'] = value;
      createNewParamRow(row);
    }
  };

  const onValueChange = (value) => {
    if (value) {
      setValue(value);
      row['value'] = value;
      createNewParamRow(row);
    }
  };

  useEffect(() => {
    setKey(row.key);
    setValue(row.value);
  }, [row, FieldSelectOptions]);

  return (
    <tr>
      <td>
        <input
          type="text"
          name="value"
          value={value}
          className="form-control form-control-sm"
          onChange={(e) => onValueChange(e.target.value)}
          placeholder="Header"
        />
      </td>
      <td>
        <select
          name="key"
          onChange={(e) => onKeyChange(e.target.value)}
          className="form-control form-control-sm custom-select-sm"
          value={key}
        >
          <option value="">-Select One-</option>
          {FieldSelectOptions.map((e) => (
            <option key={e.value} value={e.value}>
              {e.label}
            </option>
          ))}
        </select>
      </td>
    </tr>
  );
};
